import { Dialog, Stack, Typography } from "@mui/material";
import React from "react";
import { GenericIconButton } from "./GenericIconButton";
import { X } from "@phosphor-icons/react";

export const GenericDialog = ({ openDialog, children, handleClose, title, showClose = true, width, padding, titlePadding, maxWidth = 'lg', textTransform, mb = 2 }) => {
  return (
    <Dialog
      fullWidth
      open={openDialog}
      onClose={handleClose}
      maxWidth={maxWidth}
      sx={{
        '.MuiDialog-paper': {
          width: width,
          padding: padding,
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(2px)'
        },
      }}
    >
      <Stack direction={showClose ? 'row' : 'column'} justifyContent={'space-between'} alignItems={'center'} mb={mb} padding={titlePadding}>
        <Typography variant="h5" color="primary" fontWeight={700} textAlign={'center'} textTransform={textTransform}>{title}</Typography>
        {
          showClose && <GenericIconButton
            tooltip={'Close'}
            icon={<X size={20} />}
            onClick={() => handleClose()}
          />
        }
      </Stack>
      {children}
    </Dialog >
  );
};